import Vue from 'vue';
import axios from 'axios';
import { ReportsModule } from '../../types/models/report-model';

const toLower = (text: string): string => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term !== '') {
    return items.filter((item) => toLower(item['description']).includes(toLower(term)));
  }

  return items;
};

export default {
  name: 'newReports',

  props: {
    buttonText: {
      type: String,
      default: 'reports'
    },
    module: {
      type: ReportsModule,
      required: true
    },
    applicationId: {
      type: Number,
      default: 0
    },
    billingCycleId: {
      type: Number,
      default: 0
    },
    billingStep: {
      type: Number,
      default: 0
    },
    queriesLocationId: {
      type: Number,
      default: -1
    }
  },

  computed: {
    offlineModeState: function () {
      return this.$store.state.csAppsOfflineMode;
    }
  },
  data: function () {
    return {
      loading: false,
      showReportsDialog: false,

      reportsList: [],
      search: null,
      searched: [],
      selectedQueryKey: '',

      queries: []
    };
  },
  created() {
    this.getReports();
    this.getQueries();
  },
  methods: {
    getReportsImgUrl() {
      return require('../../assets/images/billing/reports.png');
    },
    searchOnTable() {
      this.searched = searchByName(this.reportsList, this.search);
    },
    getQueries() {
      if (this.offlineModeState) return;

      if (this.queriesLocationId === -1) return;

      if (this.queriesLocationId === 12 && this.billingStep !== 0) return;

      axios
        .get(`/CustomQuery/GetQueries?locationId=${this.queriesLocationId}`)
        .then((response) => {
          if (response.status == 200) {
            if (response.data == null) this.queries = [];
            else this.queries = response.data;

            if (this.queries.length > 0) {
              this.selectedQueryKey = this.queries[0].key;
            }
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        });
    },
    runQuery(queryId) {
      window.open('/queryViewer/' + queryId, '_blank');
    },
    getReports() {
      if (this.offlineModeState) return;

      this.loading = true;
      if (this.module === ReportsModule.applicationsGeneralReports) {
        this.getGeneralReports();
      } else if (this.module === ReportsModule.applicationReports) {
        this.getApplicationReports();
      } else if (this.module === ReportsModule.activityReports) {
        this.getCurrentActivityReports();
      } else if (this.module === ReportsModule.billingGeneralReports) {
        this.getBillingGeneralReports();
      } else if (this.module === ReportsModule.billingReports) {
        this.getBillingReports();
      }
    },
    getGeneralReports() {
      axios
        .get(`/EmployeeApplication/GetGeneralReports`)
        .then((response) => {
          if (response.status == 200) {
            this.reportsList = response.data;
            this.searched = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getApplicationReports() {
      axios
        .get(`/EmployeeApplication/GetApplicationReports?applicationId=${this.applicationId}`)
        .then((response) => {
          if (response.status == 200) {
            this.reportsList = response.data.items;
            this.searched = response.data.items;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCurrentActivityReports() {
      axios
        .get(`/EmployeeApplication/GetCurrentActivityReports?applicationId=${this.applicationId}`)
        .then((response) => {
          if (response.status == 200) {
            this.reportsList = response.data.items;
            this.searched = response.data.items;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBillingGeneralReports() {
      axios
        .get(`/Billing/GetGeneralReports`)
        .then((response) => {
          if (response.status == 200) {
            this.reportsList = response.data;
            this.searched = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBillingReports() {
      axios
        .get(`/Billing/GetReports`)
        .then((response) => {
          if (response.status == 200) {
            this.reportsList = response.data.filter((a) => a.step == this.billingStep);
            this.searched = response.data.filter((a) => a.step == this.billingStep);
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printReport(reportId) {
      if (this.module === ReportsModule.applicationsGeneralReports) {
        this.createApplicationGeneralReport(reportId);
      } else if (this.module === ReportsModule.applicationReports) {
        this.createApplicationReport(reportId);
      } else if (this.module === ReportsModule.activityReports) {
        this.createCurrentActivityReport(reportId);
      } else if (this.module === ReportsModule.billingGeneralReports) {
        this.createBillingGeneralReport(reportId);
      } else if (this.module === ReportsModule.billingReports) {
        this.createBillingReport(reportId);
      }
    },
    createApplicationGeneralReport(reportId) {
      axios.post(`/EmployeeApplication/CreateGeneralReport?reportId=${reportId}`),
        (response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          } else this.$alertMsg(response.data.data.text);
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
    },
    createApplicationReport(reportId) {
      const params = {
        reportId,
        applicationId: this.applicationId
      };

      axios.post(`/EmployeeApplication/CreateApplicationReport`, params),
        (response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          } else this.$alertMsg(response.data.data.text);
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
    },
    createCurrentActivityReport(reportId) {
      axios.post('/EmployeeApplication/CreateCurrentActivityReport?' + 'ApplicationId=' + this.appId + '&ReportId=' + reportId),
        (response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          } else this.$alertMsg(response.data.data.text);
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
    },
    createBillingGeneralReport(reportId) {
      axios.post(`/Billing/CreateGeneralReport?reportId=${reportId}`),
        (response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          } else this.$alertMsg(response.data.data.text);
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
    },
    createBillingReport(reportId) {
      const params = {
        billingCycleId: this.billingCycleId,
        reportId
      };

      axios.post(`/Billing/CreateReport`, params),
        (response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          } else this.$alertMsg(response.data.data.text);
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
    }
  }
};
